import { ValidationError } from '@/types/validation';
import { isNullOrUndefined } from '@/util/typeGuards';
import { DangerousOutlined, InfoOutlined, WarningAmberOutlined } from '@mui/icons-material';
import { Alert, Divider, Icon, Stack, Typography } from '@mui/material';
import { FC } from 'react';

type ErrorLineProps = {
  problem: ValidationError;
  onClick: (problem: ValidationError) => void;
};

const ErrorLine: FC<ErrorLineProps> = ({ problem, onClick }) => {
  const getProblemIcon = () => {
    switch (problem.severity) {
      case 'error':
        return DangerousOutlined;
      case 'warning':
        return WarningAmberOutlined;
      case 'info':
      default:
        return InfoOutlined;
    }
  };

  const canNavigate = !isNullOrUndefined(problem.id) || !isNullOrUndefined(problem.subroutineId);

  return (
    <Stack direction='column'>
      <Alert
        severity={problem.severity}
        icon={<Icon component={getProblemIcon()} />}
        onClick={() => onClick(problem)}
        sx={{
          pl: 4,
          pr: 4,
          pt: 0,
          pb: 0,
          cursor: canNavigate ? 'pointer' : 'default',
          '&:hover': {
            opacity: canNavigate ? 0.75 : 1
          }
        }}
      >
        <Typography variant='subtitle2' fontFamily='monospace'>
          {problem.message}
        </Typography>
      </Alert>
      <Divider />
    </Stack>
  );
};

export default ErrorLine;
